import {
  currentQuote,
  quotes as previewQuotes,
} from 'components/QuotePage/mocks';
import { QuoteCustomization } from 'components/QuotePage/Quote.models';
import { QuotePageView } from 'components/QuotePage/Quote.view';
import { useState } from 'react';

export const PreviewQuote = ({
  questionnaireAnswers,
  quoteOptions,
  mergeQuoteOptionsToQuestionnaire = false,
  prefillQuoteOptionsFromQuestionnaire = false,
  ...props
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
any) => {
  const fillQuoteOptions = !prefillQuoteOptionsFromQuestionnaire
    ? {}
    : quoteOptions.reduce(
        (
          acc: Record<string, boolean | number>,
          option: { optionKey: string }
        ) => {
          const key = option.optionKey;

          if (typeof questionnaireAnswers?.key !== 'undefined') {
            acc[key] = questionnaireAnswers[key];
          }
          return acc;
        },
        {}
      );

  const [quoteCustomization, setQuoteCustomization] =
    useState<QuoteCustomization>({
      selectedPlan: previewQuotes[0].planId ?? '',
      selectedAddons: previewQuotes[0].addons ?? [],
      selectedQuoteOptions: {
        ...fillQuoteOptions,
        ...(props?.value?.quoteOptions ?? {}),
      },
    });

  const selectedQuote = previewQuotes.find(
    (quote) => quote.planId === quoteCustomization.selectedPlan
  );

  const { selectedAddons, selectedQuoteOptions, selectedPlan } =
    quoteCustomization;

  return (
    <QuotePageView
      isInitialLoading={false}
      hasMultiplePlans={Boolean(props.table)}
      quotes={props.table ? [...previewQuotes] : previewQuotes[0]}
      selectedQuote={selectedQuote}
      selectedPlan={selectedPlan}
      selectedQuoteOptions={selectedQuoteOptions}
      selectedAddons={selectedAddons}
      setQuoteCustomization={setQuoteCustomization}
      currentQuote={currentQuote}
      quoteOptions={quoteOptions}
      mergeQuoteOptionsToQuestionnaire={mergeQuoteOptionsToQuestionnaire}
      {...props}
    />
  );
};
